import { defineStore } from "pinia";
import { ref } from "vue";
import { useUserStore } from "./user";

/**
 * UI 状态管理
 * @description 管理全局 UI 状态，如弹窗显示/隐藏等
 */
export const useUIStore = defineStore("ui", () => {
  /**
   * 账号设置弹窗相关
   */
  const accountSettingVisible = ref(false);
  
  /**
   * 显示账号设置弹窗
   */
  const showAccountSettingDialog = () => {
    accountSettingVisible.value = true;
  };

  /**
   * 隐藏账号设置弹窗
   */
  const hideAccountSettingDialog = () => {
    accountSettingVisible.value = false;
  };

  /**
   * 绑定手机号和邮箱弹窗显示状态
   */
  const bindEmailPhoneOptions = ref({
    visible: false,
    type: "email",
    closeable: true,
    oldPhone: "",
    oldPhoneAreaCode: "",
    oldEmail: "",
  });

  /**
   * 显示绑定手机号和邮箱弹窗
   */
  const showBindEmailPhoneDialog = (type: "email" | "phone", closeable?: boolean) => {
    bindEmailPhoneOptions.value.closeable = closeable ?? true;
    bindEmailPhoneOptions.value.type = type;
    bindEmailPhoneOptions.value.visible = true;
    bindEmailPhoneOptions.value.oldPhone = useUserStore().userInfo?.mobile_number || "";
    bindEmailPhoneOptions.value.oldPhoneAreaCode = useUserStore().userInfo?.mobile_prefix || "";
    bindEmailPhoneOptions.value.oldEmail = useUserStore().userInfo?.email || "";
  };

  /**
   * 隐藏绑定手机号和邮箱弹窗
   */
  const hideBindEmailPhoneDialog = () => {
    bindEmailPhoneOptions.value.visible = false;
  };

  /**
   * 积分购买弹窗显示状态
   */
  const pointsPurchaseVisible = ref(false);

  /**
   * 显示积分购买弹窗
   */
  const showPointsPurchaseDialog = () => {
    pointsPurchaseVisible.value = true;
  };

  /**
   * 隐藏积分购买弹窗
   */
  const hidePointsPurchaseDialog = () => {
    pointsPurchaseVisible.value = false;
  };

  return {
    accountSettingVisible,
    showAccountSettingDialog,
    hideAccountSettingDialog,
    bindEmailPhoneOptions,
    showBindEmailPhoneDialog,
    hideBindEmailPhoneDialog,
    pointsPurchaseVisible,
    showPointsPurchaseDialog,
    hidePointsPurchaseDialog,
  };
});
